// Helper function to extract helper addresses from raw snapshot
export const extractHelperAddresses = (
  rawData: any
): { helperAddresses: string[]; threshold: string; policySignature: string } => {
  const primaryGroup = rawData.groups?.find((group: any) => group.name === "Primary");
  if (!primaryGroup) {
    throw new Error("Primary group not found in snapshot");
  }

  const updateUserAddressPolicy = primaryGroup.nestedPolicies?.find(
    (policy: any) => policy.id === "policy-allow-updateUserAddress"
  );
  if (!updateUserAddressPolicy) {
    throw new Error("Policy 'policy-allow-updateUserAddress' not found in snapshot");
  }

  const updateUserAddressCondition = updateUserAddressPolicy.object.conditions?.find(
    (condition: any) => condition["class"] === "condition.allow_updateUserAddress"
  );
  if (!updateUserAddressCondition) {
    throw new Error("Condition 'condition.allow_updateUserAddress' not found in snapshot");
  }

  const allowedSourceParam = updateUserAddressCondition.params?.find(
    (param: any) => param.key === "allowed_source"
  );
  const thresholdParam = updateUserAddressCondition.params?.find(
    (param: any) => param.key === "threshold"
  );

  if (!allowedSourceParam || !thresholdParam) {
    throw new Error("Parameters 'allowed_source' or 'threshold' not found in condition");
  }

  return {
    helperAddresses: allowedSourceParam.value,
    threshold: thresholdParam.value,
    policySignature: updateUserAddressPolicy.object.SIGNATURE || "",
  };
};
